export default __webpack_public_path__ + "static/media/facebook.13aa0acf.svg";